var _toConsumableArray = require("/home/runner/work/is-web-dc-instore-app/is-web-dc-instore-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _objectSpread = require("/home/runner/work/is-web-dc-instore-app/is-web-dc-instore-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = t || self).objectro = {});
}(this, function (t) {
  "use strict";

  var e = Array.isArray,
      n = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
  var r = "object" == typeof n && n && n.Object === Object && n,
      o = "object" == typeof self && self && self.Object === Object && self,
      i = r || o || Function("return this")(),
      a = i.Symbol,
      u = Object.prototype,
      c = u.hasOwnProperty,
      l = u.toString,
      s = a ? a.toStringTag : void 0;

  var f = function f(t) {
    var e = c.call(t, s),
        n = t[s];

    try {
      t[s] = void 0;
      var r = !0;
    } catch (t) {}

    var o = l.call(t);
    return r && (e ? t[s] = n : delete t[s]), o;
  },
      p = Object.prototype.toString;

  var v = function v(t) {
    return p.call(t);
  },
      h = "[object Null]",
      d = "[object Undefined]",
      y = a ? a.toStringTag : void 0;

  var b = function b(t) {
    return null == t ? void 0 === t ? d : h : y && y in Object(t) ? f(t) : v(t);
  };

  var g = function g(t) {
    return null != t && "object" == typeof t;
  },
      _ = "[object Symbol]";

  var m = function m(t) {
    return "symbol" == typeof t || g(t) && b(t) == _;
  },
      j = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      O = /^\w*$/;

  var x = function x(t, n) {
    if (e(t)) return !1;
    var r = typeof t;
    return !("number" != r && "symbol" != r && "boolean" != r && null != t && !m(t)) || O.test(t) || !j.test(t) || null != n && t in Object(n);
  };

  var w = function w(t) {
    var e = typeof t;
    return null != t && ("object" == e || "function" == e);
  },
      $ = "[object AsyncFunction]",
      M = "[object Function]",
      k = "[object GeneratorFunction]",
      S = "[object Proxy]";

  var P,
      A = function A(t) {
    if (!w(t)) return !1;
    var e = b(t);
    return e == M || e == k || e == $ || e == S;
  },
      E = i["__core-js_shared__"],
      R = (P = /[^.]+$/.exec(E && E.keys && E.keys.IE_PROTO || "")) ? "Symbol(src)_1." + P : "";

  var z = function z(t) {
    return !!R && R in t;
  },
      V = Function.prototype.toString;

  var N = function N(t) {
    if (null != t) {
      try {
        return V.call(t);
      } catch (t) {}

      try {
        return t + "";
      } catch (t) {}
    }

    return "";
  },
      T = /^\[object .+?Constructor\]$/,
      F = Function.prototype,
      D = Object.prototype,
      W = F.toString,
      q = D.hasOwnProperty,
      C = RegExp("^" + W.call(q).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

  var I = function I(t) {
    return !(!w(t) || z(t)) && (A(t) ? C : T).test(N(t));
  };

  var B = function B(t, e) {
    return null == t ? void 0 : t[e];
  };

  var L = function L(t, e) {
    var n = B(t, e);
    return I(n) ? n : void 0;
  },
      G = L(Object, "create");

  var U = function U() {
    this.__data__ = G ? G(null) : {}, this.size = 0;
  };

  var H = function H(t) {
    var e = this.has(t) && delete this.__data__[t];
    return this.size -= e ? 1 : 0, e;
  },
      J = "__lodash_hash_undefined__",
      K = Object.prototype.hasOwnProperty;

  var Q = function Q(t) {
    var e = this.__data__;

    if (G) {
      var n = e[t];
      return n === J ? void 0 : n;
    }

    return K.call(e, t) ? e[t] : void 0;
  },
      X = Object.prototype.hasOwnProperty;

  var Y = function Y(t) {
    var e = this.__data__;
    return G ? void 0 !== e[t] : X.call(e, t);
  },
      Z = "__lodash_hash_undefined__";

  var tt = function tt(t, e) {
    var n = this.__data__;
    return this.size += this.has(t) ? 0 : 1, n[t] = G && void 0 === e ? Z : e, this;
  };

  function et(t) {
    var e = -1,
        n = null == t ? 0 : t.length;

    for (this.clear(); ++e < n;) {
      var r = t[e];
      this.set(r[0], r[1]);
    }
  }

  et.prototype.clear = U, et.prototype.delete = H, et.prototype.get = Q, et.prototype.has = Y, et.prototype.set = tt;
  var nt = et;

  var rt = function rt() {
    this.__data__ = [], this.size = 0;
  };

  var ot = function ot(t, e) {
    return t === e || t != t && e != e;
  };

  var it = function it(t, e) {
    for (var n = t.length; n--;) {
      if (ot(t[n][0], e)) return n;
    }

    return -1;
  },
      at = Array.prototype.splice;

  var ut = function ut(t) {
    var e = this.__data__,
        n = it(e, t);
    return !(n < 0 || (n == e.length - 1 ? e.pop() : at.call(e, n, 1), --this.size, 0));
  };

  var ct = function ct(t) {
    var e = this.__data__,
        n = it(e, t);
    return n < 0 ? void 0 : e[n][1];
  };

  var lt = function lt(t) {
    return it(this.__data__, t) > -1;
  };

  var st = function st(t, e) {
    var n = this.__data__,
        r = it(n, t);
    return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
  };

  function ft(t) {
    var e = -1,
        n = null == t ? 0 : t.length;

    for (this.clear(); ++e < n;) {
      var r = t[e];
      this.set(r[0], r[1]);
    }
  }

  ft.prototype.clear = rt, ft.prototype.delete = ut, ft.prototype.get = ct, ft.prototype.has = lt, ft.prototype.set = st;
  var pt = ft,
      vt = L(i, "Map");

  var ht = function ht() {
    this.size = 0, this.__data__ = {
      hash: new nt(),
      map: new (vt || pt)(),
      string: new nt()
    };
  };

  var dt = function dt(t) {
    var e = typeof t;
    return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
  };

  var yt = function yt(t, e) {
    var n = t.__data__;
    return dt(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
  };

  var bt = function bt(t) {
    var e = yt(this, t).delete(t);
    return this.size -= e ? 1 : 0, e;
  };

  var gt = function gt(t) {
    return yt(this, t).get(t);
  };

  var _t = function _t(t) {
    return yt(this, t).has(t);
  };

  var mt = function mt(t, e) {
    var n = yt(this, t),
        r = n.size;
    return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
  };

  function jt(t) {
    var e = -1,
        n = null == t ? 0 : t.length;

    for (this.clear(); ++e < n;) {
      var r = t[e];
      this.set(r[0], r[1]);
    }
  }

  jt.prototype.clear = ht, jt.prototype.delete = bt, jt.prototype.get = gt, jt.prototype.has = _t, jt.prototype.set = mt;
  var Ot = jt,
      xt = "Expected a function";

  function wt(t, e) {
    if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError(xt);

    var n = function n() {
      var r = arguments,
          o = e ? e.apply(this, r) : r[0],
          i = n.cache;
      if (i.has(o)) return i.get(o);
      var a = t.apply(this, r);
      return n.cache = i.set(o, a) || i, a;
    };

    return n.cache = new (wt.Cache || Ot)(), n;
  }

  wt.Cache = Ot;
  var $t = wt,
      Mt = 500;

  var kt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      St = /\\(\\)?/g,
      Pt = function (t) {
    var e = $t(t, function (t) {
      return n.size === Mt && n.clear(), t;
    }),
        n = e.cache;
    return e;
  }(function (t) {
    var e = [];
    return 46 === t.charCodeAt(0) && e.push(""), t.replace(kt, function (t, n, r, o) {
      e.push(r ? o.replace(St, "$1") : n || t);
    }), e;
  });

  var At = function At(t, e) {
    for (var n = -1, r = null == t ? 0 : t.length, o = Array(r); ++n < r;) {
      o[n] = e(t[n], n, t);
    }

    return o;
  },
      Et = 1 / 0,
      Rt = a ? a.prototype : void 0,
      zt = Rt ? Rt.toString : void 0;

  var Vt = function t(n) {
    if ("string" == typeof n) return n;
    if (e(n)) return At(n, t) + "";
    if (m(n)) return zt ? zt.call(n) : "";
    var r = n + "";
    return "0" == r && 1 / n == -Et ? "-0" : r;
  };

  var Nt = function Nt(t) {
    return null == t ? "" : Vt(t);
  };

  var Tt = function Tt(t, n) {
    return e(t) ? t : x(t, n) ? [t] : Pt(Nt(t));
  },
      Ft = 1 / 0;

  var Dt = function Dt(t) {
    if ("string" == typeof t || m(t)) return t;
    var e = t + "";
    return "0" == e && 1 / t == -Ft ? "-0" : e;
  };

  var Wt = function Wt(t, e) {
    for (var n = 0, r = (e = Tt(e, t)).length; null != t && n < r;) {
      t = t[Dt(e[n++])];
    }

    return n && n == r ? t : void 0;
  };

  var qt = function qt(t, e, n) {
    var r = null == t ? void 0 : Wt(t, e);
    return void 0 === r ? n : r;
  },
      Ct = function () {
    try {
      var t = L(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch (t) {}
  }();

  var It = function It(t, e, n) {
    "__proto__" == e && Ct ? Ct(t, e, {
      configurable: !0,
      enumerable: !0,
      value: n,
      writable: !0
    }) : t[e] = n;
  },
      Bt = Object.prototype.hasOwnProperty;

  var Lt = function Lt(t, e, n) {
    var r = t[e];
    Bt.call(t, e) && ot(r, n) && (void 0 !== n || e in t) || It(t, e, n);
  },
      Gt = 9007199254740991,
      Ut = /^(?:0|[1-9]\d*)$/;

  var Ht = function Ht(t, e) {
    var n = typeof t;
    return !!(e = null == e ? Gt : e) && ("number" == n || "symbol" != n && Ut.test(t)) && t > -1 && t % 1 == 0 && t < e;
  };

  var Jt = function Jt(t, e, n, r) {
    if (!w(t)) return t;

    for (var o = -1, i = (e = Tt(e, t)).length, a = i - 1, u = t; null != u && ++o < i;) {
      var c = Dt(e[o]),
          l = n;

      if (o != a) {
        var s = u[c];
        void 0 === (l = r ? r(s, c, u) : void 0) && (l = w(s) ? s : Ht(e[o + 1]) ? [] : {});
      }

      Lt(u, c, l), u = u[c];
    }

    return t;
  };

  var Kt = function Kt(t, e, n) {
    return null == t ? t : Jt(t, e, n);
  },
      Qt = "[object String]";

  var Xt = function Xt(t) {
    return "string" == typeof t || !e(t) && g(t) && b(t) == Qt;
  };

  var Yt = function (t, e) {
    return function (n) {
      return t(e(n));
    };
  }(Object.getPrototypeOf, Object),
      Zt = "[object Object]",
      te = Function.prototype,
      ee = Object.prototype,
      ne = te.toString,
      re = ee.hasOwnProperty,
      oe = ne.call(Object);

  var ie = function ie(t) {
    if (!g(t) || b(t) != Zt) return !1;
    var e = Yt(t);
    if (null === e) return !0;
    var n = re.call(e, "constructor") && e.constructor;
    return "function" == typeof n && n instanceof n && ne.call(n) == oe;
  };

  var ae = function ae() {
    if (!arguments.length) return [];
    var t = arguments[0];
    return e(t) ? t : [t];
  };

  var ue = function ue(t, e) {
    return null != t && e in Object(t);
  },
      ce = "[object Arguments]";

  var le = function le(t) {
    return g(t) && b(t) == ce;
  },
      se = Object.prototype,
      fe = se.hasOwnProperty,
      pe = se.propertyIsEnumerable,
      ve = le(function () {
    return arguments;
  }()) ? le : function (t) {
    return g(t) && fe.call(t, "callee") && !pe.call(t, "callee");
  },
      he = 9007199254740991;

  var de = function de(t) {
    return "number" == typeof t && t > -1 && t % 1 == 0 && t <= he;
  };

  var ye = function ye(t, n, r) {
    for (var o = -1, i = (n = Tt(n, t)).length, a = !1; ++o < i;) {
      var u = Dt(n[o]);
      if (!(a = null != t && r(t, u))) break;
      t = t[u];
    }

    return a || ++o != i ? a : !!(i = null == t ? 0 : t.length) && de(i) && Ht(u, i) && (e(t) || ve(t));
  };

  var be = function be(t, e) {
    return null != t && ye(t, e, ue);
  },
      ge = "[object Number]";

  var _e = function _e(t) {
    return "number" == typeof t || g(t) && b(t) == ge;
  };

  var me = function me(t) {
    return _e(t) && t != +t;
  },
      je = NaN,
      Oe = /^\s+|\s+$/g,
      xe = /^[-+]0x[0-9a-f]+$/i,
      we = /^0b[01]+$/i,
      $e = /^0o[0-7]+$/i,
      Me = parseInt;

  var ke = function ke(t) {
    if ("number" == typeof t) return t;
    if (m(t)) return je;

    if (w(t)) {
      var e = "function" == typeof t.valueOf ? t.valueOf() : t;
      t = w(e) ? e + "" : e;
    }

    if ("string" != typeof t) return 0 === t ? t : +t;
    t = t.replace(Oe, "");
    var n = we.test(t);
    return n || $e.test(t) ? Me(t.slice(2), n ? 2 : 8) : xe.test(t) ? je : +t;
  },
      Se = 1 / 0,
      Pe = 1.7976931348623157e308;

  var Ae = function Ae(t) {
    return t ? (t = ke(t)) === Se || t === -Se ? (t < 0 ? -1 : 1) * Pe : t == t ? t : 0 : 0 === t ? t : 0;
  };

  var Ee = function Ee(t) {
    var e = Ae(t),
        n = e % 1;
    return e == e ? n ? e - n : e : 0;
  };

  var Re = function Re(t) {
    return "number" == typeof t && t == Ee(t);
  };

  function ze(t, e, n) {
    return void 0 === n ? be(t, e) : be(t, e) && (A(n) ? !!n(qt(t, e)) : qt(t, e) === n);
  }

  function Ve(t) {
    return !!t;
  }

  function Ne(t) {
    var n = !1,
        r = arguments.length <= 1 ? 0 : arguments.length - 1;
    if (r) for (var _o = 0; _o < r; _o++) {
      if (t.indexOf(_o + 1 < 1 || arguments.length <= _o + 1 ? undefined : arguments[_o + 1]) > -1) {
        n = !0;
        break;
      }
    }
    return n;
  }

  function Te(t) {
    var n = !1,
        r = arguments.length <= 1 ? 0 : arguments.length - 1,
        o = 0;
    if (r) for (var _i = 0; _i < r; _i++) {
      if (t.indexOf(_i + 1 < 1 || arguments.length <= _i + 1 ? undefined : arguments[_i + 1]) > -1 && ++o === r) {
        n = !0;
        break;
      }
    }
    return n;
  }

  var Fe = function Fe(t, e, n) {
    return ze(e, t) && !function (t) {
      return null == t || "" === t || t instanceof Array && 0 === t.length;
    }(qt(e, t)) ? qt(e, t) : qt(n, t);
  };

  var De = /[\\^$.*+?()[\]{}|]/g,
      We = RegExp(De.source);

  var qe = function qe(t) {
    return (t = Nt(t)) && We.test(t) ? t.replace(De, "\\$&") : t;
  },
      Ce = "[object Boolean]";

  var Ie = function Ie(t) {
    return !0 === t || !1 === t || g(t) && b(t) == Ce;
  };

  var Be = function Be(t) {
    return null != t && de(t.length) && !A(t);
  },
      Le = L(i, "DataView"),
      Ge = L(i, "Promise"),
      Ue = L(i, "Set"),
      He = L(i, "WeakMap"),
      Je = N(Le),
      Ke = N(vt),
      Qe = N(Ge),
      Xe = N(Ue),
      Ye = N(He),
      Ze = b;

  (Le && "[object DataView]" != Ze(new Le(new ArrayBuffer(1))) || vt && "[object Map]" != Ze(new vt()) || Ge && "[object Promise]" != Ze(Ge.resolve()) || Ue && "[object Set]" != Ze(new Ue()) || He && "[object WeakMap]" != Ze(new He())) && (Ze = function Ze(t) {
    var e = b(t),
        n = "[object Object]" == e ? t.constructor : void 0,
        r = n ? N(n) : "";
    if (r) switch (r) {
      case Je:
        return "[object DataView]";

      case Ke:
        return "[object Map]";

      case Qe:
        return "[object Promise]";

      case Xe:
        return "[object Set]";

      case Ye:
        return "[object WeakMap]";
    }
    return e;
  });
  var tn = Ze,
      en = "[object Map]";

  var nn = function nn(t) {
    return g(t) && tn(t) == en;
  };

  var rn,
      on = function on(t) {
    return function (e) {
      return t(e);
    };
  },
      an = (function (t, e) {
    var n = e && !e.nodeType && e,
        o = n && t && !t.nodeType && t,
        i = o && o.exports === n && r.process,
        a = function () {
      try {
        var t = o && o.require && o.require("util").types;

        return t || i && i.binding && i.binding("util");
      } catch (t) {}
    }();

    t.exports = a;
  }(rn = {
    exports: {}
  }, rn.exports), rn.exports),
      un = an && an.isMap,
      cn = un ? on(un) : nn,
      ln = "[object Set]";

  var sn = function sn(t) {
    return g(t) && tn(t) == ln;
  },
      fn = an && an.isSet,
      pn = fn ? on(fn) : sn,
      vn = "[object RegExp]";

  var hn = function hn(t) {
    return g(t) && b(t) == vn;
  },
      dn = an && an.isRegExp,
      yn = dn ? on(dn) : hn,
      bn = "[object Date]";

  var gn = function gn(t) {
    return g(t) && b(t) == bn;
  },
      _n = an && an.isDate,
      mn = _n ? on(_n) : gn;

  var jn = "[object DOMException]",
      On = "[object Error]";

  var xn = function xn(t) {
    if (!g(t)) return !1;
    var e = b(t);
    return e == On || e == jn || "string" == typeof t.message && "string" == typeof t.name && !ie(t);
  };

  var wn = {
    _depth: 0,
    debug: !1,
    negateMatch: !1,
    matchAll: !1,
    skipMissingProps: !1,
    caseSensitive: !1,
    data: {}
  },
      $n = function $n() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread({}, wn, t);
  },
      Mn = function Mn() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread({}, wn, t, {
      _depth: void 0 !== t._depth && t._depth >= 0 ? t._depth + 1 : 0
    });
  },
      kn = {
    bool: Ie,
    boolean: Ie,
    string: Xt,
    number: _e,
    integer: Re,
    float: function float(t) {
      return !me(t) && _e(t) && !Re(t) && t !== 1 / 0;
    },
    array: e,
    arrayLike: Be,
    map: cn,
    set: pn,
    object: w,
    objectLike: g,
    plainObject: ie,
    function: A,
    regExp: yn,
    date: mn,
    null: function _null(t) {
      return null === t;
    },
    undefined: function undefined(t) {
      return void 0 === t;
    },
    nan: me,
    nil: function nil(t) {
      return null == t;
    },
    error: xn,
    truthy: Ve,
    falsy: function falsy(t) {
      return !t;
    }
  },
      Sn = {
    not: function not(t, e, n) {
      return Pn(t, e, Mn(_objectSpread({}, n, {
        matchAll: !1,
        negateMatch: !ze(n, "negateMatch") || !n.negateMatch
      })));
    },
    all: function all(t, e, n) {
      return Pn(t, e, Mn(_objectSpread({}, n, {
        negateMatch: !1,
        matchAll: !0
      })));
    },
    any: function any(t, e, n) {
      return Pn(t, e, Mn(_objectSpread({}, n, {
        matchAll: !1
      })));
    },
    eq: function eq(t, e) {
      return t == e;
    },
    eqs: function eqs(t, e) {
      return t === e;
    },
    gt: function gt(t, e) {
      return t > e;
    },
    gte: function gte(t, e) {
      return t >= e;
    },
    lt: function lt(t, e) {
      return t < e;
    },
    lte: function lte(t, e) {
      return t <= e;
    },
    insideRange: function insideRange(t, e) {
      return ze(e, "min") && ze(e, "max") && t > e.min && t < e.max;
    },
    withinRange: function withinRange(t, e) {
      return ze(e, "min") && ze(e, "max") && t >= e.min && t <= e.max;
    },
    withinRangeMin: function withinRangeMin(t, e) {
      return ze(e, "min") && ze(e, "max") && t >= e.min && t < e.max;
    },
    withinRangeMax: function withinRangeMax(t, e) {
      return ze(e, "min") && ze(e, "max") && t > e.min && t <= e.max;
    },
    outsideRange: function outsideRange(t, e) {
      return ze(e, "min") && ze(e, "max") && t < e.min && t > e.max;
    },
    outerRange: function outerRange(t, e) {
      return ze(e, "min") && ze(e, "max") && t <= e.min && t >= e.max;
    },
    outerRangeMin: function outerRangeMin(t, e) {
      return ze(e, "min") && ze(e, "max") && t <= e.min && t > e.max;
    },
    outerRangeMax: function outerRangeMax(t, e) {
      return ze(e, "min") && ze(e, "max") && t < e.min && t >= e.max;
    },
    re: function re(t, e, _ref) {
      var _ref$caseSensitive = _ref.caseSensitive,
          n = _ref$caseSensitive === void 0 ? !1 : _ref$caseSensitive;
      return (e instanceof RegExp ? e : new RegExp(e, n ? void 0 : "i")).test(t);
    },
    startsWith: function startsWith(t, e, _ref2) {
      var _ref2$caseSensitive = _ref2.caseSensitive,
          n = _ref2$caseSensitive === void 0 ? !1 : _ref2$caseSensitive;
      return new RegExp("^".concat(qe("".concat(e))), n ? void 0 : "i").test(t + "");
    },
    endsWith: function endsWith(t, e, _ref3) {
      var _ref3$caseSensitive = _ref3.caseSensitive,
          n = _ref3$caseSensitive === void 0 ? !1 : _ref3$caseSensitive;
      return new RegExp("".concat(qe("".concat(e)), "$"), n ? void 0 : "i").test(t + "");
    },
    contains: function contains(t, n, _ref4) {
      var _ref4$caseSensitive = _ref4.caseSensitive,
          r = _ref4$caseSensitive === void 0 ? !1 : _ref4$caseSensitive;
      return e(t) ? t.indexOf(n) > -1 : r ? t.indexOf(n) > -1 : new RegExp("".concat(qe(n)), "i").test(t);
    },
    includesAny: function includesAny(t, e) {
      return Ne.apply(void 0, [ae(t)].concat(_toConsumableArray(ae(e))));
    },
    includesAll: function includesAll(t, e) {
      return Te.apply(void 0, [ae(t)].concat(_toConsumableArray(ae(e))));
    },
    type: function type(t, e) {
      return ze(kn, e, A) && kn[e](t);
    },
    has: function has(t, n, r) {
      var o = !1,
          i = 0,
          a = 0;

      if (Xt(n) || e(n)) {
        var _e2 = ae(n);

        if (i = _e2.length, ze(r, "matchAll", Ve)) {
          for (var _n2 = 0; _n2 < i; _n2++) {
            var _o2 = _e2[_n2];
            !ze(r, "skipMissingProps", Ve) || ze(t, _o2) || ze(r, "data.".concat(_o2)) ? a += ze(t, _o2) || ze(r, "data.".concat(_o2)) ? 1 : 0 : i--;
          }

          o = a === i;
        } else for (var _n3 = 0; _n3 < i; _n3++) {
          var _a = _e2[_n3];

          if (!ze(r, "skipMissingProps", Ve) || ze(t, _a) || ze(r, ["data", _a])) {
            if (ze(t, _a) || ze(r, ["data", _a])) {
              o = !0;
              break;
            }
          } else i--;
        }
      } else if (w(n)) {
        var _u = Object.keys(n);

        i = _u.length;

        for (var _c = 0; _c < i; _c++) {
          var _l = _u[_c];

          if (ze(r, "skipMissingProps", Ve) && !ze(t, _l) && !ze(r, ["data", _l])) {
            i--;
            continue;
          }

          var _s = e(t) || ze(t, _l) ? qt(t, _l) : ze(r, ["data", _l]) ? qt(r, ["data", _l]) : void 0,
              _f = ae(_s),
              _p = ae(n[_l]);

          if (o = ze(r, "matchAll", Ve) ? Te.apply(void 0, [_f].concat(_toConsumableArray(_p))) : Ne.apply(void 0, [_f].concat(_toConsumableArray(_p)))) {
            if (a++, !ze(r, "matchAll", Ve)) break;
            o = a === i;
          }
        }
      }

      return o;
    },
    match: function match(t, e, n) {
      var r = !1,
          o = 0,
          i = 0;

      if (w(e)) {
        var _a2 = Object.keys(e);

        i = _a2.length;

        for (var _u2 = 0; _u2 < i; _u2++) {
          var _c2 = _a2[_u2];

          if (ze(n, "skipMissingProps", Ve) && !ze(t, _c2) && !ze(n, "data.".concat(_c2))) {
            i--;
            continue;
          }

          var _l2 = qt(e, _c2);

          if (r = Pn(ze(t, _c2) ? qt(t, _c2) : ze(n, "data.".concat(_c2)) ? qt(n.data, _c2) : void 0, _l2, $n({
            data: n.data || {}
          }))) {
            if (o++, !ze(n, "matchAll", Ve)) break;
            r = o === i;
          }
        }
      }

      return r;
    }
  };

  function Pn(t, e, n) {
    var r = $n(_objectSpread({}, n, {
      _depth: qt(n, "_depth", 0)
    }));
    var o = 1,
        i = 0,
        a = !1;

    var u = function u(_ref5) {
      var t = _ref5.ruleName,
          e = _ref5.ruleValue,
          n = _ref5.input,
          r = _ref5.options,
          o = _ref5.isValid;
      o && i++, r.debug;
    };

    if (A(e)) (a = e(t, e, r)) && u({
      ruleName: "fn",
      ruleValue: e,
      input: t,
      options: r,
      isValid: a
    });else {
      var _n4 = Object.keys(e);

      o = _n4.length;

      for (var _c3 = 0; _c3 < o; _c3++) {
        var _l3 = _n4[_c3],
            _s2 = e[_l3];
        if (A(_s2)) a = _s2(t, _s2, r);else if (ze(Sn, _l3, A)) {
          a = (0, Sn[_l3])(t, _s2, r);
        }

        if (a) {
          if (u({
            ruleName: _l3,
            ruleValue: _s2,
            input: t,
            options: r,
            isValid: a
          }), !ze(r, "matchAll", Ve) || i === o) break;
          a = !1;
        } else u({
          ruleName: _l3,
          ruleValue: _s2,
          input: t,
          options: r,
          isValid: a
        });
      }
    }
    return ze(r, "negateMatch", Ve) ? !a : a;
  }

  var An = function t(n) {
    var o = Object.freeze(_objectSpread({}, n)),
        i = {};

    for (var _len = arguments.length, r = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      r[_key - 1] = arguments[_key];
    }

    return r && r.length ? (r.forEach(function (r) {
      if (Xt(r)) {
        var _t2 = Fe(r, n, i);

        void 0 !== _t2 && Kt(i, r, _t2);
      } else ie(r) && Object.keys(r).forEach(function (a) {
        var u = Fe(a, n, i),
            c = qt(r, a);

        if (A(c)) {
          var _t3 = c(u, a, o, i);

          void 0 !== _t3 && (ie(_t3) ? i = _objectSpread({}, i, _t3) : Kt(i, a, _t3));
        } else ie(u) && (ie(c) || e(c)) ? Kt(i, a, t.apply(void 0, [u].concat(_toConsumableArray(ae(c))))) : Xt(c) && void 0 !== u && Kt(i, c, u);
      });
    }), i) : _objectSpread({}, n);
  },
      En = Pn;

  var Rn = {
    transform: An,
    validate: En
  };
  t.default = Rn, t.transform = An, t.validate = En, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});